/* eslint-disable @typescript-eslint/no-explicit-any */
import { debounce } from 'lodash';
import { useCallback } from 'react';

function useDebouncedOnChange<T = any>(
  onChange: (value: T) => void,
  time = 500,
) {
  const debounceChange = useCallback(debounce(onChange, time), []);

  return debounceChange;
}

export default useDebouncedOnChange;
